const convertBRDateToIso8601 = date => {
  date = date.replace(/\D/g, "")
  date = `${date.substr(4, 4)}-${date.substr(2, 2)}-${date.substr(0, 2)}`
  return date
}

export default convertBRDateToIso8601
